import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcClockFillH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 1.6a7.4 7.4 0 1 1 0 14.801 7.4 7.4 0 0 1 0-14.8m0 3a.65.65 0 0 0-.65.65v3.44c0 .371.148.728.41.99l2.03 2.03a.65.65 0 0 0 .92-.92L9.68 8.76a.1.1 0 0 1-.03-.07V5.25A.65.65 0 0 0 9 4.6"
  }));
}
var IcClockFillH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcClockFillH18));

export { IcClockFillH18 as I };
